import {
  FeatureFlagsContext,
  type FeatureGroup,
} from "@/providers/FeatureFlagProvider";
import { useContext } from "react";

// Custom Hook API
export function useFeatures(): FeatureGroup {
  return useContext(FeatureFlagsContext);
}
